export default __webpack_public_path__ + "static/media/header-tubes.9ef2587a.jpg";